import { render, staticRenderFns } from "./ImageProcessingSettings.vue?vue&type=template&id=bec250f6&scoped=true"
import script from "./ImageProcessingSettings.vue?vue&type=script&lang=js"
export * from "./ImageProcessingSettings.vue?vue&type=script&lang=js"
import style0 from "./ImageProcessingSettings.vue?vue&type=style&index=0&id=bec250f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec250f6",
  null
  
)

export default component.exports